import {
  TCreatePasswordPayload,
  TLoginPayload,
  TSendOtpPayload,
  TVerifyOtpPayload,
} from "@/interfaces";
import { authClient } from "@/services/auth.service";
import { useMutation } from "@tanstack/react-query";

export const useLoginMutation = () => {
  return useMutation({
    mutationFn: async (payload: TLoginPayload) => {
      return await authClient.login({ payload });
    },
  });
};
export const useSendOtpMutation = () => {
  return useMutation({
    mutationFn: async (payload: TSendOtpPayload) => {
      return await authClient.sendOtp({ payload });
    },
  });
};

export const useVerifyOtpMutation = () => {
  return useMutation({
    mutationFn: async (payload: TVerifyOtpPayload) => {
      return await authClient.verifyOtp({ payload });
    },
  });
};

export const useGetUserTokenMutation = () => {
  return useMutation({
    mutationFn: async (payload: TVerifyOtpPayload) => {
      return await authClient.getUserToken(payload);
    },
  });
};

export const useCreatePasswordMutation = (token?: string) => {
  return useMutation({
    mutationFn: async (payload: TCreatePasswordPayload) => {
      return await authClient.createPassword({ payload, token });
    },
  });
};
export const useChangePasswordMutation = useCreatePasswordMutation;
